import React from "react";
import { ProductSearch } from "./ProductSearch.tsx";
import { CheckoutPreviewInHeader } from "./CheckoutPreviewInHeader.tsx";
import { UserBox } from "./UserBox.tsx";

export const ProductsAndOrderItemsHeader: React.FC = () => (
  <div className="flex flex-row justify-between h-header bg-white border-b-1 border-solid border-border-light">
    <ProductSearch />
    <div className="flex flex-row items-center w-1/2 lg:w-4/7 xl:w-1/2 justify-between pl-2 2xl:pl-4 pr-2 2xl:pr-4">
      <CheckoutPreviewInHeader />
      <UserBox />
    </div>
  </div>
)
